/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.11.0
 * @since 1.0.0
 */

import { memo } from 'react';

import { Button, LinkBlock } from '../../../components/common';
import { ICommonTranslation } from '../../../modules/internationalization/types';
import { initTranslation } from '../../internationalization/constants';
import {
    ExportMessageContainerStyled,
    ExportMessageDescriptionStyled,
    ExportMessageTitleStyled,
    FooterContainerStyled,
} from './styled/ExportMessageStyled';

export interface IExportMessageProps {
    handleClose: () => void;
    handleSubmit?: () => void;
    translation: ICommonTranslation;
}

const ExportMessage = (props: IExportMessageProps) => {

    const { handleClose, handleSubmit, translation } = props;

    return (
        <ExportMessageContainerStyled
            data-component={'modal-popup'}
            data-name={'export-message-popup'}
        >
            <ExportMessageTitleStyled data-name='modal-popup-title'>
                {translation.export.popupTitle}
            </ExportMessageTitleStyled>
            <ExportMessageDescriptionStyled>
                {translation.export.popupText}
            </ExportMessageDescriptionStyled>
            <FooterContainerStyled>
                <Button
                    className="export-message__apply-btn"
                    disabled={false}
                    kind="mediumNormal"
                    onClick={handleSubmit}>
                    {translation.export.export}
                </Button>
                <LinkBlock
                    className="export-message__cancel-btn"
                    onClick={handleClose}
                >
                    {translation.export.cancel}
                </LinkBlock>
            </FooterContainerStyled>
        </ExportMessageContainerStyled>
    );
};

ExportMessage.defaultProps = {
    translation: initTranslation.common,
};

export default memo(ExportMessage);
